import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const CommonDropdown = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle className="dropdown-btn">
        All Appointments <span className="material-icons md-18">expand_more</span>
      </DropdownToggle>
      <DropdownMenu>
          <DropdownItem>
            All
          </DropdownItem>
          <DropdownItem>
            Pending Appointments
          </DropdownItem>
          <DropdownItem>
            Upcoming Appointments
          </DropdownItem>
          <DropdownItem>
            Canceled Appointments
          </DropdownItem>
          <DropdownItem>
            Completed Appointments
          </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default CommonDropdown;